/**
 * Bundled demo screenplay (original work, written for Kinetix) so a first-time visitor can feel
 * the whole pipeline without risking their own pages. Three scenes, two speaking parts, one prop.
 */

export const SAMPLE_SCRIPT_FILE_NAME = "Sample — The Last Lighthouse.txt";

export const SAMPLE_SCRIPT_TEXT = `THE LAST LIGHTHOUSE
A short film

EXT. SEA CLIFF — LIGHTHOUSE — DUSK

Storm light. A white lighthouse stands on a black cliff, its lamp dark.
MARA VOSS (60s, oilskin coat, hands like rope) climbs the cliff path
carrying a brass lamp cage. Far below, the sea takes bites out of the rocks.

MARA
Forty years I kept you lit. One night off, and look at you.

She shoulders the door open.

INT. LIGHTHOUSE — LAMP ROOM — NIGHT

A spiral of iron stairs. Mara sets the brass cage beside the great dead lens.
A YOUNG MAN (20s, soaked through, no coat) is already there, sitting on the
floor like he has been waiting for years. His name is ITTO.

ITTO
The light went out on a Thursday. I counted every day since.

MARA
Nobody counts that high.

ITTO
Out there you do.

Mara studies him. The storm leans on the glass. She begins, slowly, to fit
the lamp into the lens housing.

MARA
Then help me. We have until the wave gets here.

EXT. SEA CLIFF — LIGHTHOUSE — NIGHT

The wave comes — a moving cliff of black water. The lamp room flares alive.
A blade of light swings out across the sea and cuts the wave's crest like a
signature. The water folds around the cliff and does not take it.

On the gallery rail, Mara and Itto watch the beam turn.

ITTO
What do we do tomorrow?

MARA
Same thing. We keep it lit.

THE END
`;
